import { ref, type Ref } from 'vue';
import { createReview } from '@/shared/api/experience';
import type { ArticleResponse } from '@/shared/api/experience';
import { getBootstrapData } from '@experience/core-hostapp-share-lib';

export const useArticleReview = (data: Ref<ArticleResponse | null>) => {
  const review = ref<number | null>(-1);
  const isReviewSuccessToastOpen = ref(false);

  const getReview = () => {
    const articleId = data.value?.article_details?.id;
    if (articleId == null) {
      return;
    }
    const raw = localStorage.getItem(`articles_review_type_${articleId}`);
    if (raw === null) {
      review.value = null;
      return;
    }
    const reviewType = Number(raw);
    review.value = reviewType === 0 || reviewType === 1 ? reviewType : null;
  };

  const setReview = (reviewType: number) => {
    const articleId = data.value?.article_details?.id;
    if (articleId == null) {
      return;
    }
    const key = `articles_review_type_${articleId}`;
    if (reviewType !== 0 && reviewType !== 1) {
      localStorage.removeItem(key);
      review.value = null;
    } else {
      localStorage.setItem(key, String(reviewType));
      review.value = reviewType;
    }
  };

  const sendReaction = (reviewType: number, _sendSoguEvent: boolean, storeReview: boolean) => {
    if (storeReview) {
      setReview(reviewType);
    }
  };

  const sendReview = async (reviewType: number, text: string) => {
    const articleId = data.value?.article_details?.id;
    if (articleId == null) {
      return;
    }
    const rawDeviceId = getBootstrapData().deviceId;
    if (rawDeviceId == null) {
      return;
    }
    const deviceIdForReview: string = rawDeviceId;
    const res = await createReview({
      body: {
        review_type: reviewType,
        text,
        device_id: deviceIdForReview,
      },
      path: { pageType: 'articles', articleId },
    });
    if (res.data) {
      isReviewSuccessToastOpen.value = true;
      if (reviewType === 0 || reviewType === 1) {
        setReview(reviewType);
      }
    }
  };

  return {
    review,
    isReviewSuccessToastOpen,
    getReview,
    sendReaction,
    sendReview,
  };
};
